import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import CategoryNav from "./components/CategoryNav";
import TrendingSection from "./components/TrendingSection";
import HotArticles from "./components/HotArticles";
import DailyUpdate from "./components/DailyUpdate";
import CTASection from "./components/CTASection";

const siteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "每日黑料",
  url: "https://www.meiriheiliao.com",
  description: "每日黑料网✨聚焦每日黑料大赛入口、每日黑料吃瓜网最新地址，黑料每日爆料与网红塌房现场直击，每日更新吃瓜内容。",
  potentialAction: {
    "@type": "SearchAction",
    target: "https://www.meiriheiliao.com/search?q={search_term_string}",
    "query-input": "required name=search_term_string",
  },
};

const orgSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "每日黑料",
  url: "https://www.meiriheiliao.com",
  description: "每日黑料大赛入口，黑料每日爆料，网红塌房现场直击",
  foundingDate: "2023",
  contactPoint: {
    "@type": "ContactPoint",
    email: "contact@meiriheiliao.com",
    telephone: "400-888-6666",
    contactType: "customer service",
    availableLanguage: ["Chinese"],
  },
  address: {
    "@type": "PostalAddress",
    addressLocality: "北京",
    addressRegion: "北京",
    addressCountry: "CN",
  },
};

export default function Home() {
  return (
    <>
      <script type="application/ld+json">{JSON.stringify(siteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>

      <Navbar />

      <main>
        <article>
          <HeroSection />
          <CategoryNav />
          <TrendingSection />
          <HotArticles />
          <DailyUpdate />
          <CTASection />
        </article>
      </main>

      <Footer />
    </>
  );
}